var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navigation'),_c('div',{staticClass:"col-md-12 billing-section"},[(!_vm.subscriptionState.isLifeTime)?_c('pricePlan'):_vm._e(),(!!_vm.subscriptionState.isLifeTime)?_c('productCodeRedemption'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }